import { useRef, useEffect } from "react";

export function useVerticalScroll() {
  const elRef = useRef();
  useEffect(() => {
    const el: any = elRef.current;
    if (el) {
      const onWheel = e => {

      };
      el.addEventListener("wheel", onWheel);
      return () => el.removeEventListener("wheel", onWheel);
    }
  }, []);
  return elRef;
}